var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Lottie',{ref:"lottie",staticClass:"lottie-wrapper",attrs:{"animation-data":_vm.lottieFile,"auto-play":true,"loop":true,"width":"clamp(100px, 10vw, 200px)","height":"clamp(100px, 10vw, 150px)"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }